import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const EmailSendFile = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SendFile/FileSendToEmail`, data);